import Assessment from '../assessment';

/**
 * Create the action
 */

const { thunk, request, success, error } = Assessment.show((id, fetch) =>
  fetch.get(`/assessments/${id}`)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
